import React from 'react'
import { GroupContainer } from '../GroupContainer'
import { useTranslation } from '../../../../../utils/convergence'
import { useSummaryDetailsViewModel } from '../../../hooks/useSummaryDetailsViewModel'

export const DueTodaySection = (): JSX.Element => {
  const { t } = useTranslation()
  const { totalDueTodayAmount } = useSummaryDetailsViewModel()

  return <GroupContainer name={t('summary:dueToday')} amount={totalDueTodayAmount} expandable></GroupContainer>
}
